import { post } from "@rails/request.js"
import { Controller } from "stimulus"

const ROW_SELECTOR = "tr.inventory-row";
const ERROR_BORDER = "error-border";


export default class extends Controller{

  static targets = ["uploadForm", "uploadInput", "validate", "finalize", "validationResults"]

  setState(validate, finalize, results){
    this.validateTarget.disabled = !validate;
    this.finalizeTarget.disabled = !finalize;
    this.validationResultsTarget.style.display = (results ? "block" : "none");
  }

  onFileChange(event){
    // everything is false except validate button toggles
    const fileSelected = (this.uploadInputTarget.files.length > 0);
    this.setState(fileSelected, false, false);
  }

  async processUpload(event){

    event.preventDefault();

    event.target.disabled = true;

    const formData = new FormData(this.uploadFormTarget);
    const response = await post(event.params.url, {body: formData});

    if (response.ok)
      this.displayValidationResults(await response.json);

  }

  displayValidationResults(response){

    if (response.finalized)
      Turbo.visit(response.finalized_url);
    else {
      this.validationResultsTarget.innerHTML = response.result_html;
      this.setState(true, response.success, true);
    }
  }

}


